export default "__VITE_ASSET__73475462__"